module.exports = __webpack_public_path__ + "img/radar-dish.60a37f06.svg";